// Copyright (c) 2019 Deere & Company

import { readDuplicatePinPlate } from './get-duplicate-pin-plate';
import { resetDuplicatePinPlate } from './reset-duplicate-pin-plate';
import { updateDuplicatePinPlateStatus } from './put-duplicate-pin-plate';

export default {
    readDuplicatePinPlate,
    resetDuplicatePinPlate,
    updateDuplicatePinPlateStatus,
};
